class DiceUtil {
    static dice(faces) {
        return Math.floor(Math.random() * faces + 1);
    }

    static diceLoop(faces, count) {
        let value = 0;
        for (let i = 0; i < count; i++) {
            value += this.dice(faces);
        }
        return value;
    }

    static multipleDiceLoops(array) {
        let value = 0;
        let data = null;
        for (let i = 0; i < array.length; i++) {
            data = array[i];
            value += this.diceLoop(data.faces, data.count);
        }
        return value;
    }

    static d100(count) {
        return this.diceLoop(100, count);
    }
}

export default DiceUtil;


// WEBPACK FOOTER //
// ./src/utils/DiceUtil.js